module.exports = __webpack_public_path__ + "static/media/vegitables_60.d8271a61.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_60.csv
// module id = 647
// module chunks = 0